import { Injectable, Renderer2, RendererFactory2, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DarkModeService {
    private renderer: Renderer2;
    private darkModeMediaQuery: MediaQueryList;
    public isDarkMode = signal<boolean>(false);

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        this.isDarkMode.set(this.darkModeMediaQuery.matches);
    }

    // Initialize dark mode based on system preference
    initDarkMode(): void {
        this.updateDarkMode();
        // Listen for changes in system preference
        this.darkModeMediaQuery.addListener((event) => {
            this.isDarkMode.set(event.matches);
            this.updateDarkMode();
        });
    }

    // Apply dark mode classes to the body
    private updateDarkMode(): void {
        if (this.isDarkMode()) {
            this.renderer.addClass(document.body, 'dark');
        } else {
            this.renderer.removeClass(document.body, 'dark');
        }
    }
}